<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset"  (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">SLA Configuration</div>

  </div>
  <div class="modal-body font-13">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <mat-radio-group (change)="onFuncTypeChange($event)">
        <mat-radio-button value="category_change" [checked]="true">On Category Change</mat-radio-button>&nbsp;&nbsp;
        <mat-radio-button value="reopen">On ReOpen Ticket</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="form-group">
      <mat-radio-group (change)="onSLATypeChange($event)">
        <mat-radio-button value="new" [checked]="true">Start Over SLA</mat-radio-button>&nbsp;
        <mat-radio-button value="resume">Resume SLA</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>
